import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiImageModule } from '@digipay/ng-ui-api-image';
import { Store } from '../../data-access/models/store.type';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';
import { ServiceImagesType } from '@client-monorepo/common/ui-components';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { NgxIcon } from '@digipay/ngx-icon';
import { PipesModule } from '@digipay/ng-lib-pipes';

@Component({
  selector: 'daily-stores-store-preview',
  standalone: true,
  imports: [CommonModule, ApiImageModule, NgxSkeletonLoadingComponent, NgxBadgeModule, NgxIcon, PipesModule],
  templateUrl: './store-preview.component.html',
  styleUrl: './store-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StorePreviewComponent {
  store = input<Store>({} as Store);
  mode = input<'horizontal-big' | 'horizontal-small' | 'vertical-large' | 'vertical-medium' | 'logo-only'>('vertical-medium');
  isLoading = input(false);
  classes = input<string>('');
  ServiceImagesType = ServiceImagesType;
}
